module.exports = __webpack_public_path__ + "static/cardOnSide-8daa115253cad5eaae190628f901c87b.png";